import styled from 'styled-components';

const Badge = styled.span`
  font-weight: bold;
  color: ${({ hasErrors = false }) => (hasErrors ? 'yellow' : 'white')};
`;

export default Badge;
